export default __webpack_public_path__ + "static/media/mirar-la-platja.49764fd8.jpg";